// extracted by mini-css-extract-plugin
export default {"Page":"ComplexOrder_Page__EOqTQ","Filters":"ComplexOrder_Filters__-sC0L","List":"ComplexOrder_List__UYgi0","Loader":"ComplexOrder_Loader__G0KZH"};